import { BooleanStore } from 'stores';

import { PaymentsStore } from './payments';

const editModalStore = new BooleanStore();
const paymentsStore = new PaymentsStore();

export { editModalStore, paymentsStore };
